import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";
import "../../plugins/canvasloader";

var invoice = (function () {

    var dashboard = $('body.dashboard'),
		invoiceTable = $('.t-invoice');

    if (invoiceTable.length > 0) {

        var main = $('#main'),
            loadMoreBtn = $('#show-more'),
            source = $("#invoice-item-template").html(),
            template = Handlebars.compile(source),
            responseWrap = $('.response-wrapper'),
            cl = new CanvasLoader('loader');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        if (dashboard.length === 0) {
            
            setTimeout(function(){
                getInvoices(8);
            }, 100);

            main.on('click', '#show-more', function () {
                getInvoices(8);

                return false;
            });
        } else {
            setTimeout(function () {
                getInvoices(7);
            }, 100);
        }
    }

    function getInvoices(pagesize) {
        var invoiceNumber = invoiceTable.find('tbody tr:last-child .t-invoiceno').html();

        var data = {
            lastShowingInvoice: invoiceNumber,
            pageSize: pagesize
        };

        loadMoreBtn.addClass('loading');
        cl.show();

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.admin.methods.getInvoices,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);
    }

    function doneHandler(response) {

        if (response.Success) {
            var html = template(response.Data);

            if (!response.MoreAvailable) {
                loadMoreBtn.hide();
            }

            cl.hide();
            invoiceTable.find('tbody').append(html);
        } else {

            displayGenericError(responseWrap, response);
            cl.hide();

        }
        loadMoreBtn.removeClass('loading');
    }

    function failHandler(jqXHR, textStatus, errorThrown) {
        serviceNetworkError(responseWrap);
        cl.hide();
    }


})();